import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { ContractListItemOwnersModule } from '../../domain/contract/components/contract-list-item-owners/contract-list-item-owners.module'
import { DisplayAcreagePipeModule } from '../../domain/parcel/pipes/display-acreage.pipe.module'
import { SubjectUserBadgeModule } from '../../domain/subject/components/subject-user-badge/subject-user-badge.module'
import { DisplayAddressModule } from '../../domain/subject/pipes/display-address.module'
import { DisplayCountTenantsModule } from '../../domain/subject/pipes/display-count-tenants.module'
import { DisplayNamePipeModule } from '../../domain/subject/pipes/display-name.module'
import { LoadingModule } from '../../shared/ui/loading/loading.module'
import { CommandPaletteComponent } from './command-palette.component'

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        LoadingModule,
        DisplayNamePipeModule,
        DisplayAddressModule,
        DisplayAcreagePipeModule,
        DisplayCountTenantsModule,
        SubjectUserBadgeModule,
        ContractListItemOwnersModule
    ],
    declarations: [CommandPaletteComponent],
    exports: [CommandPaletteComponent]
})
export class CommandPaletteModule {}
